export const REQUEST_DOCUMENT_TYPES = [
  { value: 'DNI/NIE/NIF/PASAPORTE', translationKey: 'requestFiles.types.identity' },
  { value: 'factura', translationKey: 'requestFiles.types.invoice' },
  { value: 'contrato', translationKey: 'requestFiles.types.contract' },
  { value: 'escritura', translationKey: 'requestFiles.types.deed' },
  { value: 'cédula de habitabilidad', translationKey: 'requestFiles.types.habitabilityCertificate' },
  { value: 'documentación de agua', translationKey: 'requestFiles.types.waterDocumentation' },
  { value: 'persona física', translationKey: 'requestFiles.types.naturalPerson' },
  { value: 'copia de número de cuenta', translationKey: 'requestFiles.types.bankAccountCopy' },
  { value: 'contrato o escritura', translationKey: 'requestFiles.types.contractOrDeed' },
  { value: 'boletín', translationKey: 'requestFiles.types.certificate' },
  { value: 'autorización', translationKey: 'requestFiles.types.authorization' },
  { value: 'CIF/DNI autorizado', translationKey: 'requestFiles.types.authorizedIdentity' },
  { value: 'contrato de luz', translationKey: 'requestFiles.types.lightContract' },
  { value: 'contrato de gas', translationKey: 'requestFiles.types.gasContract' },
  { value: 'contrato de luz y gas', translationKey: 'requestFiles.types.dualContract' },
  { value: 'otros', translationKey: 'requestFiles.types.other' },
];

export const getRequestDocumentTypeOptions = (translate) => (
  REQUEST_DOCUMENT_TYPES.map(({ value, translationKey }) => ({
    value,
    label: translate(translationKey),
  }))
);
